"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _breakpoints = _interopRequireWildcard(require("./breakpoints"));

var unit = 'px';

var getBreakpointValue = function getBreakpointValue(key) {
  if (typeof key === 'string') {
    return _breakpoints["default"][key];
  }

  if (typeof key === 'number') {
    return key;
  }

  throw new Error('Invalid key value');
};

var createQuery = function createQuery(key, value) {
  return "(".concat(key, ": ").concat(value, ")");
};

var media = function media(query) {
  return "@media ".concat(query);
};

var upQuery = function upQuery(key) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    strict: false
  };
  var breakpointValue = opts.strict ? getBreakpointValue(key) + 1 : getBreakpointValue(key);
  return createQuery('min-width', "".concat(breakpointValue).concat(unit));
};

var downQuery = function downQuery(key) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    strict: true
  };
  var breakpointValue = opts.strict ? getBreakpointValue(key) - 1 : getBreakpointValue(key);
  return createQuery('max-width', "".concat(breakpointValue).concat(unit));
};

var up = function up(key, opts) {
  return media(upQuery(key, opts));
};

var down = function down(key, opts) {
  return media(downQuery(key, opts));
};

var between = function between(startKey, endKey) {
  var upQueryValue = upQuery(startKey, {
    strict: false
  });
  var downQueryValue = downQuery(endKey, {
    strict: false
  });
  return media("".concat(upQueryValue, " and ").concat(downQueryValue));
};

var only = function only(key) {
  return between(key, key);
};

var _default = {
  breakpoints: _breakpoints.breakpointsConstants,
  up: up,
  down: down,
  between: between,
  only: only,
  upQuery: upQuery,
  downQuery: downQuery
};
exports["default"] = _default;